module.exports = __webpack_public_path__ + "img/UTDEAD-6.94347f8b.jpg";